<template>
  <b-container fluid>
    <b-row class="footer-section">
      <b-col class="left-footer" lg="7" md="6">
        <div>
          <p>
            Incubated at IIT Madras-Healthcare Technology Innovation
            Center's(HTIC)
          </p>
          <span>Feedback</span>
          <span>Support</span>
          <span @click="$emit('helpclick')">Helpcenter</span>
        </div>
      </b-col>
      <b-col class="right-footer" lg="5" md="6">
        <p>A Product of</p>
        <span @click="goBack"><img src="../../assets/Img/MoceroLogo.png" /></span>
        <div class="version">
          <h6>V 1.1</h6>
          <p>VERSION</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const goBack = () => {
      // window.location.href = 'https://www.mocerohealth.com/';
      window.open("https://www.mocerohealth.com/", "_blank");
    };
    return {
      goBack,
    };
  },
});
</script>

<style lang="scss">
.footer-section {
  width: 102%;
  margin-right: auto !important;
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  // border-radius: 10px;
  align-items: center;
  padding: 5px 0px;

  .left-footer div {
    display: flex;
    align-items: center;

    p {
      color: #444444;
      font-size: 14px;
      font-weight: 500;
      padding-right: 15px;
    }

    span {
      cursor: pointer;
      color: #0881fc;
      font-size: 12px;
      padding-right: 10px;
    }
  }

  .right-footer {
    display: flex;
    align-items: center;
    justify-content: end;

    p {
      color: #444444;
      font-size: 14px;
      font-weight: 500;
      padding-right: 15px;
    }

    img {
      width: 120px;
    }

    .version {
      background-color: #f7f7f7;
      border-radius: 10px;
      padding: 5px;
      width: max-content;
      text-align: center;
      margin-left: 10px;

      h6 {
        font-size: 14px;
        font-weight: 500 !important;
      }

      p {
        font-size: 10px;
        color: #999999;
        padding-right: 0px;
      }
    }
  }
}

@media only screen and (max-width: 992px) {
  .footer-section {
    margin-left: 1% !important;
  }
}

@media only screen and (max-width: 750px) {
  .left-footer div {
    p {
      font-size: 12px;
    }
  }
}

@media only screen and (max-width: 767px) {
  .left-footer {
    display: none;
  }
}
</style>
